// extracted by mini-css-extract-plugin
export default {"uploadContainer":"InputFile_uploadContainer__9s7U2"};